// Libraries from npm that the site's scripts, and inline scripts in views, use as globals
import $ from 'jquery'
import _ from 'lodash'
import Masonry from 'masonry-layout'

window.jQuery = window.$ = $
window._ = _
window.Masonry = Masonry
